import { useForm } from 'react-hook-form';
import Toaster from '../../../Components/Toaster/Toaster';
import Loader from '../../../Components/Spinner/Loader';
import { Button } from 'react-bootstrap';
import {
  useGetVisitorProfileData,
  useVisitorProfileUpdate,
} from '../apiEndpoints/VisitorApiEndpoints';
import InputField from '../../../Components/Common/InputField';
import SelectField from '../../../Components/Common/SelectField';
import moment from 'moment';
import SelectTextArea from '../../../Components/Common/SelectTextArea';
import CommonTouchFieldForEdit from '../../../Components/Common/CommonTouchFieldForEdit';

const VisitorEditProfile = () => {
  const Toast = Toaster();
  const { data } = useGetVisitorProfileData();
  const { mutate, isPending } = useVisitorProfileUpdate();
  const {
    register,
    handleSubmit,
    formState: { dirtyFields },
    getValues,
  } = useForm<any>();
  const onSubmit = async () => {
    const formData = new FormData();
    const currentValues = getValues();

    const editFields = CommonTouchFieldForEdit({
      dirtyFields,
      currentValues,
      existingValues: data?.data,
    });

    if (editFields && !Object?.keys(editFields)?.length) {
      return Toast.fire({
        icon: 'error',
        title: 'Change field first',
      });
    } else {
      Object.keys(editFields).forEach((item) => {
        formData.append(item, currentValues[item]);
      });
      mutate(formData);
    }
  };

  return (
    <>
      <div className='profile-right-side px-3 py-3'>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='section-title-cs edit-sec-cs'>
            <h4 className='component-tittle'> Profile Info</h4>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <div>
                  <InputField
                    type='text'
                    label='First Name'
                    register={register('visitor_first_name')}
                    placeholder='Enter first name'
                    defaultValue={data?.data?.visitor_first_name}
                  />
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <div>
                  <InputField
                    type='text'
                    label='Last Name'
                    register={register('visitor_last_name')}
                    placeholder='Enter last name'
                    defaultValue={data?.data?.visitor_last_name}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <div>
                  <InputField
                    label='Email'
                    register={register('visitor_email')}
                    type='email'
                    placeholder='Enter email address'
                    defaultValue={data?.data?.visitor_email}
                  />
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <InputField
                  label='Mobile Number'
                  register={register('visitor_phone')}
                  placeholder='Enter mobile number'
                  defaultValue={data?.data?.visitor_phone}
                />
              </div>
            </div>

            <div className='row'>
              {/* <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <SelectField
                  label='Gender'
                  register={register('visitor_gender')}
                  placeholder='Enter last name'
                  options={[
                    { value: 'male', label: 'Male' },
                    { value: 'female', label: 'Female' },
                  ]}
                  defaultValue={data?.data?.visitor_gender}
                />
              </div> */}
              {/* <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <InputField
                  type='date'
                  label='Date of Birth'
                  defaultValue={moment(
                    data?.data?.visitor_date_of_birth
                  ).format('YYYY-MM-DD')}
                  register={register('visitor_date_of_birth')}
                  placeholder='Enter date of birth'
                />
              </div> */}
            </div>

            <div className='row'>
              {/* <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <SelectField
                  label='Profession'
                  register={register('visitor_profession')}
                  placeholder='Profession'
                  options={[
                    { value: 'Business', label: 'Business' },
                    { value: 'Govt. Job', label: 'Govt. Job' },
                    { value: 'Private Job', label: 'Private Job' },
                    { value: 'Doctor', label: 'Doctor' },
                    { value: 'Engineer', label: 'Engineer' },
                    { value: 'Teacher', label: 'Teacher' },
                    { value: 'Student', label: 'Student' },
                    { value: 'Software Engineer', label: 'Software Engineer' },
                    { value: 'Lawyer', label: 'Lawyer' },
                    { value: 'Architect', label: 'Architect' },
                    { value: 'Police Officer', label: 'Police Officer' },
                    { value: 'Journalist', label: 'Journalist' },
                    { value: 'Artist', label: 'Artist' },
                    { value: 'Actor', label: 'Actor' },
                    { value: 'Pharmacist', label: 'Pharmacist' },
                    { value: 'Nurse', label: 'Nurse' },
                    { value: 'Freelancer', label: 'Freelancer' },
                    { value: 'Entrepreneur', label: 'Entrepreneur' },
                    { value: 'Retired', label: 'Retired' },
                    { value: 'Unemployed', label: 'Unemployed' },
                    { value: 'Others', label: 'Others' },
                  ]}
                  defaultValue={data?.data?.visitor_profession}
                />
              </div> */}
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <InputField
                  label='Designation'
                  defaultValue={data?.data?.visitor_designation}
                  register={register('visitor_designation')}
                  placeholder='Enter Designation'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <InputField
                  label='Organization'
                  defaultValue={data?.data?.visitor_organization}
                  register={register('visitor_organization')}
                  placeholder='Enter Organization'
                />
              </div>
            </div>
            <div className='row'>
              {/* <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <InputField
                  label='Website'
                  defaultValue={data?.data?.visitor_website}
                  register={register('visitor_website')}
                  placeholder='Enter Website'
                />
              </div> */}
            </div>

            <div className='section-title-cs edit-sec-cs'>
              <h4 className='profile-title'> Address &amp; Location </h4>
              <div className='row mb-3'>
                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                  <SelectTextArea
                    type='text'
                    label='Address'
                    register={register('visitor_address')}
                    placeholder='Enter address'
                    defaultValue={data?.data?.visitor_address}
                    rows={3}
                  />
                </div>
                {/* <div className='col-12 col-sm-12 col-md-12 col-lg-6'>
                  <InputField
                    label='City'
                    defaultValue={data?.data?.visitor_city}
                    register={register('visitor_city')}
                    placeholder='Enter city'
                  />
                </div>
                <div className='col-12 col-sm-12 col-md-12 col-lg-6'>
                  <InputField
                    label='Postal Code'
                    defaultValue={data?.data?.visitor_zip_code}
                    register={register('visitor_zip_code')}
                    placeholder='Enter Postal Code'
                  />
                </div> */}
              </div>
            </div>
            {/* <div className='section-title-cs edit-sec-cs'>
              <h4 className='profile-title'> Social Media</h4>

              <div className='row'>
                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                  <InputField
                    label='Facebook'
                    defaultValue={data?.data?.visitor_facebook}
                    register={register('visitor_facebook')}
                    placeholder='Enter facebook'
                  />
                </div>
              </div>
            </div> */}
            <div className='col-12 col-sm-12 col-md-12 mt-4'>
              <div className='col-lg-offset-2 col-lg-12 text-end'>
                {isPending ? (
                  <Loader css={'text-white'} />
                ) : (
                  <Button
                    style={{
                      backgroundColor: '#1982c3',
                      color: 'white',
                      borderRadius: '5px',
                      border: 'none',
                    }}
                    type='submit'
                    value='1'
                    name='update_profile'
                  >
                    Update
                  </Button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default VisitorEditProfile;
